import { ChangeEvent, FC } from 'react';

import { LimitTypesEnum } from '@/constants/common';

import * as S from './RangeInputs.styles';

interface RangeInputsProps {
  label: string;
  onChange: (value: number | string) => void;
  onBlur: () => void;
  type: LimitTypesEnum;
  value: number;
  min: number;
  max: number;
  isChanged: boolean;
}

export const RangeInputs: FC<RangeInputsProps> = ({
  label,
  isChanged,
  onChange,
  onBlur,
  value,
  type,
  min,
  max
}) => {
  const VALUE = {
    [LimitTypesEnum.MIN]: min,
    [LimitTypesEnum.MAX]: max
  };

  const isDefault = VALUE[type] === value;
  const placeholder = `${VALUE[type]}`;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const formattedValue = Number(e.target.value.replace(/\D/g, ''));
    const clampedValue = Math.max(min, Math.min(max, formattedValue));
    onChange(clampedValue);
  };

  const computedValue = `${isDefault && !isChanged ? '' : value}`;
  const charactersLength = `${isDefault ? placeholder : value}`.length;

  const isActive = !isDefault || isChanged;
  return (
    <S.InputContainer>
      <S.Label>{label}</S.Label>

      <S.Input
        $width={`calc(${charactersLength}ch + 1ch)`}
        placeholder={placeholder}
        value={computedValue}
        min={min}
        max={max}
        type="text"
        data-testid={`range-input-${type.toLowerCase()}`}
        $isActive={isActive}
        inputMode="decimal"
        onChange={handleChange}
        onBlur={onBlur}
      />

      <S.CurrencyWrapper $isActive={isActive}>₼</S.CurrencyWrapper>
    </S.InputContainer>
  );
};
